module.exports = __webpack_public_path__ + "static/media/sergiu_ojoc.6626e78f.jpg";